module.exports = __webpack_public_path__ + "static/media/MorningBriefing.097cdd2e.png";